import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ProjectPage from './pages/ProjectPage';
import BungalowDetail from './pages/BungalowDetail';
import Reports from './pages/Reports';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/projects/skyora" element={<ProtectedRoute><ProjectPage projectCode="SKY" /></ProtectedRoute>} />
        <Route path="/projects/sylvan-villas" element={<ProtectedRoute><ProjectPage projectCode="MAY" /></ProtectedRoute>} />
        <Route path="/skyora/:unitNumber" element={<ProtectedRoute><BungalowDetail projectCode="SKY" /></ProtectedRoute>} />
        <Route path="/sylvan-villas/:unitNumber" element={<ProtectedRoute><BungalowDetail projectCode="MAY" /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
